import { useState } from "react";
import pako from "pako";
import * as actionFunction from "../../../actions/common";

const useFetchPost = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchPostData = async (url, data, encrypt = true) => {
		setLoading(true);
		try {
			const response = await fetch(url, {
				method: "POST",
				// headers: {
				// 	"Content-Type": "application/json",
				// },
				body: encrypt ? JSON.stringify(data) : pako.gzip(JSON.stringify(data)),
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			let responseData;
			if (encrypt) {
				responseData = await response.json();
				// console.log(responseData, "Response");
			} else {
				const responseDataBuffer = await response.arrayBuffer();
				responseData = await actionFunction.decompressjsondata(responseDataBuffer);
			}
			setLoading(false);
			return responseData;
		} catch (error) {
			setLoading(false);
			setError(error);
		}
	};

	return { fetchPostData, loading, error };
};

export default useFetchPost;



// WEBPACK FOOTER //
// ./src/components/crm/hooks/useFetchPost.js